import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import * as Styles from './MockupHeader.style';
import { navLinks, socialMediaLinks } from 'utils/nav-links-util';
import VmUtils from 'pages/member/new-vm/util';
import { CustomHeader } from '@sidraaabdullah/test-shared-library';
import { H6 } from 'components/reusable-css';
import { languageArray } from 'constants/signUp';
import { Icon } from 'semantic-ui-react';
import { mockUiprofilemenu, mockUserAccountDetails, mockUserUiDetails } from '../constant';
import moment from 'moment';

export default function MockupHeader({ isAppDrawerOpen, setIsAppDrawerOpen }) {
  const { t, i18n } = useTranslation();
  let defaultLang = i18n.language == 'en-US' ? 'en' : i18n.language;
  const [language, setLanguage] = useState(defaultLang);
  const { newVmPath } = VmUtils();
  const handleNavigate = async () => {};

  const handleLanguage = async (value) => {
    setLanguage(value);
    i18n.changeLanguage(value);
  };
  const handleNavigateAccount = async () => {};

  const onAppDrawerToggle = () => {
    setIsAppDrawerOpen(!isAppDrawerOpen);
  };

  return (
    <CustomHeader
      isAppDrawerOpen={isAppDrawerOpen}
      onAppDrawerToggle={onAppDrawerToggle}
      profileMenu={mockUiprofilemenu}
      handleLogout={handleNavigate}
      account_approved={1}
      handleLanguage={handleLanguage}
      language={language}
      rights={mockUserAccountDetails.user_rights}
      userUi={mockUserUiDetails}
      string2={t('string2')}
      header={{
        string1: (
          <Trans
            i18nKey={'header.string1'}
            components={{
              changelog_link: <Styles.ChangelogLink to={'/mockup/changelog'} target="_blank" />,
              text: <Styles.Text />,
            }}
            values={{
              version: mockUserUiDetails.portal_version,
              username: mockUserUiDetails.username,
              release_date: moment(mockUserUiDetails.portal_release_date).format('MMMM DD, YYYY'),
            }}
          />
        ),
        string2: (
          <Trans
            i18nKey={'header.string2'}
            components={{
              changelog_link: <Styles.ChangelogLink to={'/mockup/changelog'} target="_blank" />,
              text: <Styles.Text />,
            }}
            values={{
              version: mockUserUiDetails.portal_version,
              username: mockUserUiDetails.username,
              release_date: moment(mockUserUiDetails.portal_release_date).format('MMMM DD, YYYY'),
            }}
          />
        ),
        string3: (
          <Trans
            i18nKey={'header.string3'}
            values={{
              account_price: 'USD $0.00',
              buck_price: '$9,695.12',
            }}
          />
        ),
        string4: (
          <Trans i18nKey={'header.string4'}>
            <a href={'#' + newVmPath}>{t('virtual server')}</a>
            <a href={'#' + navLinks.new_server.link}>{t('bare metal server')}</a>
          </Trans>
        ),
        string5: t('header.string5'),
        string6: t('header.string6'),
        string7: t('header.string7'),
        string8: t('header.string8'),
      }}
      Heading6={H6}
      socialMediaLinks={socialMediaLinks(mockUserUiDetails)}
      navLinks={navLinks}
      languageArray={languageArray}
      AccountLabel={Styles.AccountLabel}
      TriggerContainer={Styles.TriggerContainer}
      HeaderSC={Styles.HeaderSC}
      LeftHeader={Styles.LeftHeader}
      Para={Styles.Para}
      RightHeader={Styles.RightHeader}
      SocialMediaLink={Styles.SocialMediaLink}
      drawerList={
        <div>
          {mockUiprofilemenu?.accountmenu?.map((link, i) =>
            link.external_link === '1' ? (
              <Styles.AchorTag key={i} href={link.url} target="blank">
                <Icon name={link.menu_icon} />
                <div>{t(link.api_language_string_title)}</div>
              </Styles.AchorTag>
            ) : (
              <Styles.LinkSC onClick={() => handleNavigateAccount(link)} key={link.id} href={`#${link.url}`}>
                <Icon name={link.menu_icon} />
                <div>{t(link.api_language_string_title)}</div>
              </Styles.LinkSC>
            ),
          )}
        </div>
      }
    />
  );
}
